import { connect } from 'react-redux';
import { IRootState } from 'redux/reducer';
import { selectRouteResource } from 'redux/routing/selectors';
import { selectVariantContextId } from 'redux/variantContext/selectors';
import { rrc } from 'utils/strings/resourceClasses';

import { WithObatMenu as WithObatMenuComponent } from './WithObatMenu.component';

export interface IOwnProps {
  isCollapsed?: boolean;
  selectedPage: string;
}

export type IStateProps = ReturnType<typeof mapStateToProps>;
export type IDispatchProps = typeof mapDispatchToProps;
export type IInjectedProps = IStateProps & IDispatchProps;
export type IProps = IOwnProps & IInjectedProps;

const mapStateToProps = (rootState: IRootState) => {
  return {
    routeObat: selectRouteResource(rrc.obat)(rootState),
    variantContextId: selectVariantContextId(rootState),
  };
};

const mapDispatchToProps = {};

export const WithObatMenu = connect(mapStateToProps, mapDispatchToProps)(WithObatMenuComponent);
